import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bell } from "lucide-react";
import { TrendSparkline } from "./TrendSparkline";

const money = (v, currency) => `${(v || 0).toFixed(4)} ${String(currency || "usd").toUpperCase()}`;

// خارطة اللون النصي (Tailwind class) إلى hex — لأن recharts لا يفهم Tailwind.
const HEX = {
  "text-fuchsia-500": "#d946ef", "text-emerald-500": "#10b981", "text-cyan-500": "#06b6d4",
  "text-violet-500": "#8b5cf6", "text-orange-500": "#f97316", "text-sky-500": "#0ea5e9",
};

export const ProviderCostCard = ({ providerKey, calls, units, cost, currency, threshold, onSaveThreshold,
                                    trend, Icon, color = "text-primary" }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(threshold ?? 0);
  useEffect(() => { setValue(threshold ?? 0); }, [threshold]);
  const exceeded = threshold > 0 && cost > threshold;

  return (
    <div className={`rounded-2xl bg-background p-4 shadow-neu-in ${exceeded ? "ring-2 ring-destructive/60" : ""}`}
         data-testid={`ops-card-${providerKey}`}>
      <div className="flex items-center gap-2">
        <Icon className={`h-4 w-4 ${color}`} />
        <p className="text-sm font-black">{t(`opsCosts.providers.${providerKey}.name`)}</p>
        {exceeded ? <Bell className="ms-auto h-4 w-4 animate-pulse text-destructive" /> : null}
      </div>
      <p className="mt-1 text-[10px] text-muted-foreground">{t(`opsCosts.providers.${providerKey}.action`)}</p>
      <div className="mt-3 grid grid-cols-3 gap-2 text-center">
        <div>
          <p className="text-[10px] text-muted-foreground">{t("opsCosts.calls")}</p>
          <p className="font-mono text-sm font-bold">{calls || 0}</p>
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground">{t(`opsCosts.providers.${providerKey}.unit`)}</p>
          <p className="font-mono text-sm font-bold">{(units || 0).toLocaleString("en-US")}</p>
        </div>
        <div>
          <p className="text-[10px] text-muted-foreground">{t("opsCosts.cost")}</p>
          <p className={`font-mono text-sm font-black ${exceeded ? "text-destructive" : color}`}>{money(cost, currency)}</p>
        </div>
      </div>
      {trend?.length ? <TrendSparkline data={trend} color={HEX[color] || "#6366f1"} currency={String(currency || "usd").toUpperCase()} /> : null}
      <label className="mt-3 flex items-center gap-2 rounded-xl bg-background px-3 py-2 shadow-neu-sm">
        <Bell className="h-3.5 w-3.5 text-amber-500" />
        <span className="text-[10px] text-muted-foreground">{t("opsCosts.threshold")}</span>
        <input type="number" min="0" step="1" value={value} data-testid={`ops-threshold-${providerKey}`}
               onChange={(e) => setValue(Number(e.target.value))}
               onBlur={() => value !== threshold && onSaveThreshold?.(providerKey, value)}
               className="ms-auto w-20 rounded-lg bg-background px-2 py-1 text-end font-mono text-xs shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring" />
        <span className="text-[10px] text-muted-foreground">USD/{t("opsCosts.monthShort")}</span>
      </label>
    </div>
  );
};
